export default __webpack_public_path__ + "static/media/1433.a7c325a5.png";